import { render } from "./PokemonPage.vue?vue&type=template&id=2b7def70"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=2b7def70&scope=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\programming\\vue\\vue-apuntes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__